import moment from "moment";
import { APP_CONST } from "../store/dataStore";
import { kycStatuses } from "../store/constants";
import BigNumber from "bignumber.js";

export const numberFormatter = (str, fraction = 3) => {
  const bn = new BigNumber(str);
  return bn.toFormat(fraction);
};

export const dollarViewFormatter = number =>
  APP_CONST.USD_SYMBOL + numberFormatter(number, 2);

export const rielViewFormatter = number => numberFormatter(number, 0);

export const moneyTableViewFormatter = (amount, row) =>
  row.currencyName === "KHR"
    ? rielViewFormatter(amount)
    : dollarViewFormatter(amount);

/**
 * Date formatter function
 *
 * @param {number | number[]} date - A date input
 * @param {object} [options] - An options object
 * @param {boolean} [options.showTime=true] - Show or hide the time in a date. Default: true
 * @param {string} [options.dateFormat="seconds"] - Format of input date. Default: "seconds"
 *
 * @returns {string} - Formatted date
 */
export const dateFormatter = (date, options = {}) => {
  const {
    showTime = true,
    dateFormat = "seconds",
    withoutUnknown = false,
  } = options;

  if (date === undefined || date === null || date === "") {
    if (withoutUnknown) {
      return Date.now();
    } else {
      return "unknown";
    }
  }

  const format = showTime ? APP_CONST.DATETIME_FORMAT : APP_CONST.DATE_FROM;
  const CAMBODIAN_TIMEZONE_OFFSET = 7;

  switch (dateFormat) {
    default:
    case "seconds":
      return moment(date * 1000)
        .utcOffset(CAMBODIAN_TIMEZONE_OFFSET)
        .format(format);
    case "array":
      return moment(Array.isArray(date) ? date.join("/") : null, "YYYY/MM/DD")
        .utcOffset(CAMBODIAN_TIMEZONE_OFFSET)
        .format(format);
  }
};

/**
 * KYC status formatter
 *
 * @param {String} status Raw KYC status string
 * @returns {String} Formatted status
 *
 * Example: input: FULL_KYC, output: Full KYC
 */
export const kycStatusFormatter = status => {
  const { statusDesc } = kycStatuses[status] || {};

  if (!statusDesc) return status;

  return statusDesc;
};
